import styled from "styled-components";

export const CreateEventContainer = styled.div`
  margin: 2% auto;
  height: 904px;
  width: 90%;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 80px;
`;

export const CreateEventContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  margin-top: 1rem;
  flex: 1;
  overflow-y: auto;
`;

export const BackButton = styled.div`
  width: 80px;
  color: #8692a6;
  margin-left: -10px;
  margin-bottom: 0.75rem;
  cursor: pointer;
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: 600;
`;

export const CreateEventTitle = styled.div`
  font-size: 32px;
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 3px;
  text-decoration-color: #fe3f67;
  text-underline-offset: 4px;
  width: 236px;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
`;
export const Text2 = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
`;

export const ExamineAndVerify = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  line-height: 20px;
`;
export const ProgressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  margin: 20px 0;
`;

export const ProgressLine = styled.div`
  width: 100%;
  position: absolute;
  top: 30%;
  left: 5%;
  width: 90%;
  transform: translateY(-50%);
  background-color: #8692a6;
  height: 4px;
  z-index: 1;
`;

export const Stage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;

  p {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
    text-align: center;
    color: #8692a6;
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
  }

  &.active p {
    color: black;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const Circle = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #8692a6;
  border-radius: 50%;
  background-color: white;
  color: #8692a6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;

  &.active {
    border-color: #fe2f67;
    color: #fe2f67;
  }
`;

export const CreateEventFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: white;
  border-top: 1px solid #e5e5e5;
  border-radius: 0 0 20px 20px;
`;

export const BackStageButton = styled.button`
  padding: 10px 20px;
  background: none;
  border: 1.25px solid #8692a6;
  color: #8692a6;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  min-width: 180px;

  &:hover {
    background: #8692a6;
    color: white;
  }
`;

export const ContinueButton = styled.button`
  padding: 10px 20px;
  background: #fe2f67;
  border: none;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  min-width: 180px;

  &:hover {
    background: #e62a5d;
  }
`;

export const StageContainer = styled.div`
  width: 100%;
  height: 510px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #fe2f67;
    border-radius: 10px;
  }
`;

export const StageTitle = styled.div`
  margin-bottom: 5px;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
`;

export const FieldTitle = styled.div`
  margin-bottom: 7px;
  margin-top: 7px;
  font-size: 14px;
  font-weight: 400px;
`;

export const EventImageContainer = styled.div`
  width: 100%;
  max-width: 473px;
  height: 153px;
  border: 1px solid #878787;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #8f8f8f;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  user-select: none;
`;
export const EventImageContainerUrl = styled.div`
  width: 100%;
  max-width: 814px;

  input {
    width: 100%;
    height: 38px;
    border: 1px solid #878787;
    border-radius: 5px;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    padding: 10px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #fe2f67;
    }
  }
`;

export const EventNameContainer = styled.div`
  width: 100%;
  max-width: 814px;

  input {
    width: 100%;
    height: 38px;
    border: 1px solid #878787;
    border-radius: 5px;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    padding: 10px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #fe2f67;
    }
  }
`;

export const EventDetailsContainer = styled.div`
  width: 100%;
  max-width: 814px;

  textarea {
    width: 100%;
    height: 170px;
    border: 1px solid #878787;
    border-radius: 5px;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    padding: 10px;
    outline: none;
    box-sizing: border-box;
    resize: none;

    &:focus {
      border-color: #fe2f67;
    }
  }
`;

export const EventGoalContainer = styled.div`
  width: 100%;
  max-width: 814px;

  input {
    width: 100%;
    height: 38px;
    border: 1px solid #878787;
    border-radius: 5px;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    padding: 10px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #fe2f67;
    }
  }
`;

export const Container = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

export const SelectedList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
  min-height: 35px;
`;

export const SelectedCauseTag = styled.div`
  display: flex;
  align-items: center;
  background: #fe2f67;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  gap: 8px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding-bottom: 10px;
`;

export const Card = styled.div<{ selected: boolean }>`
  position: relative;
  min-width: 200px;
  height: 150px;
  background: ${(props) => (props.selected ? "#ffffff" : "#f9f9f9")};
  border: 2px solid ${(props) => (props.selected ? "#FE2F67" : "#ddd")};
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const CardTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  padding: 8px;
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
`;

export const CheckIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  background: #fe2f67;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
`;

export const ScrollBar = styled.div`
  width: 100%;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  margin-top: 10px;
  position: relative;
`;

export const ScrollThumb = styled.div`
  width: 20%;
  height: 100%;
  background: #fe2f67;
  border-radius: 3px;
  position: absolute;
  left: 0;
`;

export const FieldTitle2 = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  line-height: 24px;
`;

export const TimeZones = styled.select`
  width: 70%;
  height: 38px;
  border: 1px solid #878787;
  border-radius: 5px;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  padding: 10px;
  outline: none;
  box-sizing: border-box;
  resize: none;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &:focus {
    border-color: #fe2f67;
  }
`;

export const FormRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  gap: 130px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DateInput = styled.input`
  width: 100%;
  max-width: 200px;
  height: 38px;
  border: 1px solid #878787;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    border-color: #fe2f67;
    outline: none;
  }
`;

export const Dropdown = styled.select`
  width: 100%;
  min-width: 180px;
  height: 38px;
  border: 1px solid #878787;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    border-color: #fe2f67;
    outline: none;
  }

  option {
    padding: 10px;
    font-family: "Arial", sans-serif;
    text-align: left;
  }
`;

export const EndTimeButton = styled.div`
  color: #fe2f67;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  align-items: center;
  margin-bottom: 5px;

  @media (max-width: 850px) {
    width: 100%;
  }
`;

export const LocationContainer = styled.div`
  margin-top: 10px;
`;

export const LocationScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding-bottom: 10px;
`;

export const LocationCard = styled.div<{ selected: boolean }>`
  position: relative;
  min-width: 140px;
  height: 50px;
  background: ${(props) => (props.selected ? "#ffffff" : "#f9f9f9")};
  border: 2px solid ${(props) => (props.selected ? "#FE2F67" : "#ddd")};
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
`;

export const LocationCheckIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  background: #fe2f67;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
`;

export const LocationCardTitle = styled.div`
  font-size: 12px;
  font-weight: bold;
  padding: 8px;
`;

export const CollaborationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #fe2f67;
  }

  &:checked + span:before {
    transform: translateX(18px);
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const PrivacyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-top: 16px;
`;

export const PrivacyOption = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  font-size: 16px;

  input {
    display: none;
  }

  .radio-circle {
    width: 20px;
    height: 20px;
    border: 2px solid #ff1493;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: "";
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff1493;
      transform: scale(0);
      transition: transform 0.2s ease-in-out;
    }
  }

  input:checked + .radio-circle::after {
    transform: scale(1);
  }

  .lock-icon {
    font-size: 18px;
    color: #ff1493;
  }

  .description {
    font-size: 14px;
    color: #6c6c6c;
    margin-top: 4px;
  }
`;

export const LocationFormRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  gap: 80px;
`;

export const InputContainer = styled.div`
  width: 100%;

  input {
    width: 100%;
    height: 38px;
    border: 1px solid #878787;
    border-radius: 5px;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    padding: 10px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #fe2f67;
    }
  }
`;

export const AttendeesContainer = styled.div``;

export const AttendeesSearchBar = styled.input`
  width: 75%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 20px;

  &:focus {
    border-color: #fe2f67;
    outline: none;
  }
`;

export const AttendeesListContainer = styled.div`
  margin-left: 25px;
  display: flex;
  gap: 00px;
`;

export const AttendeesList = styled.div`
  flex: 1;
`;

export const InvitedList = styled.div`
  flex: 1;
`;

export const AttendeeCard = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const AttendeesAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 10px;
  text-align: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AttendeesInfo = styled.div`
  flex: 1;
  max-width: 250px;

  .name {
    font-size: 16px;
    font-weight: bold;
  }

  .type {
    font-size: 14px;
    color: #fe2f67;
  }
`;

export const AttendeesInviteButton = styled.button`
  background: none;
  border: 2px solid #fe2f67;
  color: #fe2f67;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;

  &:hover {
    background: #fe2f67;
    color: white;
  }

  &.active {
    background: #fe2f67;
    color: white;
  }
`;

export const AttendeesRemoveButton = styled.button`
  background: none;
  border: none;
  color: #fe2f67;
  font-size: 20px;
  cursor: pointer;
`;
